<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('checkpage') }} </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo(type)"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo('checkpageList')"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('checkpageList') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            sm="3"
            md="3"
          >
            <autocomplete
              v-model="bank"
              :rules="[v => !!v || $t('is-required')]"
              :title="$t('bank')"
              type="bank"
              :set-init="true"
              :value="bank"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
            class="mb-0  "
          >
            <v-text-field
              v-model="count"
              :label="$t('count')"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
            class="mb-0  "
          >
            <v-text-field
              v-model="firstnumber"
              :label="$t('firstNumberPage')"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
            class="mb-0  "
          >
            <v-chip
              color="primary"
              label
              outlined
            >
              {{ $t('lastNumberPage') }} : {{ lastnumber }}
            </v-chip>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              v-if="!formType"
              color="grey"
              outlined
              class="float-left"
              @click="goTo( 'checkpageList' )"
            >
              {{ $t('checkpageList') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../Mixins/general'
  export default {
    name: 'Product',
    components: {
      autocomplete: () => import('../../components/general/patial/autocomplete'),
    },
    mixins: [General],
    props: ['formType'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      render: false,
      isLoading: false,
      alert: false,
      firstnumber: null,
      type: null,
      bank: null,
      count: null,
      valid: null,
      name: null,
      id: null,
      loading: false,
    }),
    computed: {
      lastnumber () {
        if (this.count && this.firstnumber) {
          return parseFloat(this.count) + parseFloat(this.firstnumber) - parseFloat(1)
        } else {
          return ''
        }
      },
    },
    watch: {
      defaultCurrency () {
        if (this.defaultCurrency && this.$refs.refCurrency) {
          this.$refs.refCurrency.setModel(this.defaultCurrency)
          this.currency_amount = this.defaultCurrency.amount
        }
      },
      currency (val, old) {
        if (val) {
          this.currency_amount = val.amount
          this.options.suffix = val.symbol
        } else {
          this.options.suffix = ' '
          this.currency_amount = null
        }
      },
    },
    beforeMount () {
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      } else {
        this.render = true
        this.defaultCurrency = this.getDefault('defaultCurrency')
      }
    },
    mounted () {
      if (this.formType) {
        this.type = this.formType
      }
    },
    methods: {
      create () {
        var app = this
        app.alert = false
        app.isLoading = true
        // app.currency = app.defaultCurrency
        app.$axios.post(this.$endpoint + 'checkpage', app.$data)
          .then(res => {
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
            if (app.id) {
            } else {
              app.$emit('input', res.data.data)
            }
            app.goTo('checkpageList')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
            // this.clearForm()
          })
      },
      show () {
        var app = this
        app.clearForm()
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'bank/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.type = res.type
              app.typeForm = res.type
              app.id = res.id
              app.name = res.name
              app.number = res.number
              app.initial_price = res.initial_price
              app.currency = res.currency
              app.currency_amount = res.currency_amount
              app.content = res.content
              if (res.tags) {
                app.tag = res.tags
              }
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'bank/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.$emit('close', app.$route)
            app.goTo(app.type + 'List')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      clearForm () {
        this.firstnumber = null
        this.bank = null
        this.count = null
        this.valid = null
        this.name = null
        this.id = null
      },
    },
  }
</script>

<style scoped>

</style>
